/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuperadminUserDto } from '../../models/superadmin-user-dto';

export interface SuperadminControllerGetUser$Params {
  uuid: string;
}

export function superadminControllerGetUser(http: HttpClient, rootUrl: string, params: SuperadminControllerGetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetUser.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuperadminUserDto>;
    })
  );
}

superadminControllerGetUser.PATH = '/superadmin/users/{uuid}';
